// extracted by mini-css-extract-plugin
module.exports = {"panelTitle":"VectorLayerObservadors_panelTitle__3NUd6","panel":"VectorLayerObservadors_panel__16Fjz"};